import { render } from "./addquotation.vue?vue&type=template&id=50cb7c9d&scoped=true"
import script from "./addquotation.vue?vue&type=script&lang=js"
export * from "./addquotation.vue?vue&type=script&lang=js"

import "./addquotation.vue?vue&type=style&index=0&id=50cb7c9d&scoped=true&lang=css"

import exportComponent from "/Users/arthaskyline/Documents/FILE_DELFIN/kodingan-arthaskyline/level-up/levelup-github/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50cb7c9d"]])

export default __exports__